import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import BlastreamPlayer from './BlastreamPlayer';
import PlayerBuilder from './builder/PlayerBuilder';
//import { BlastreamPlayerReactComponent } from './BlastreamPlayerReactComponent';

//import BlastreamPlayerReactComponent from '../dist/react/index';

import {
  Control,
  ControlSubmenu,
  ControlMiddle,
  ProgressBar,
  ClickAction,
  Hover,
  TextTrack,
  UiElement,
  Autoplay,
  QualityLevel,
  AudioTrack,
  Orientation,
  ShortcutAction,
  BigButtonPosition,
  ControlsPosition,
  PluginControlPosition,
  PlaybackMode,
  TextTrackKind,
  StreamType,
  SourceType,
  LogoPosition,
  ProgressBarPosition,
  Fit,
} from './types/player';
import PluginInterface from './sdk/plugins/PluginInterface';
import Play from './components/controls/Play';
import { Provider } from './components/Context';
import { Stream } from 'stream';
import Logo from './components/controls/Logo';
import Fullscreen from './components/controls/Fullscreen';

const urlParams = new URLSearchParams(window.location.search);

let source = {
  //url: 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8',
  //url: 'https://synople-records.s3.gra.io.cloud.ovh.net/custom/p34277/master.m3u8',
  //url: 'https://www.blastream.com/wp-content/uploads/2022/03/video-homepage.mp4',
  //url: 'https://samplelib.com/lib/preview/mp4/sample-5s.mp4',
  //url: 'http://sample.vodobox.com/planete_interdite/planete_interdite_alternate.m3u8',
  //url: 'https://dash.akamaized.net/akamai/bbb_30fps/bbb_30fps.mpd',
  //url: 'https://live3.blastream.com/live_test/test/playlist.m3u8',
  //url: '',
  //url: 'https://playertest.longtailvideo.com/adaptive/alt-audio-no-video/sintel/playlist.m3u8',
  url: 'https://strhlslb01.streamakaci.tv/str_tchad_tchad/str_tchad_multi/playlist.m3u8',
  //url : 'https://dash.akamaized.net/dash264/TestCasesIOP41/MultiTrack/alternative_content/2/manifest_alternative_content_ondemand.mpd' //multi video track
  //url : 'https://livesim2.dashif.org/vod/testpic_2s/cea608_and_segs.mpd' //multi text track with image
  //url : 'https://dash.akamaized.net/dash264/TestCasesIOP41/MultiTrack/alternative_content/2/manifest_alternative_content_ondemand.mpd' //multi video track
};
const firstUrl = source.url;
const url = urlParams.get('url');
if (url) {
  source.url = url;
}

/*
import PluginsManager from './sdk/plugins/PluginsManager';

class Quanteec implements PluginInterface {
  
  sdk: BlastreamPlayer = null as any;
  pluginsManager: PluginsManager = null as any;
  
  init(sdk: BlastreamPlayer, pluginsManager: PluginsManager): void {
    this.sdk = sdk;
    this.pluginsManager = pluginsManager;
  }

  async beforePlayerInit() {

  }
  
  async afterPlayerInit() {

  }
  
  destroy(): void {

  }
  
  getName(): string {
    return 'Quanteec';
  }
  
  getVersion(): string {
    return '1.0.0';
  }

}*/

async function initPlayer() {
  /*const cssResponse = await fetch('/celine/style.css');
  const customCSS = await cssResponse.text();

  const jsResponse = await fetch('celine/script.js');
  const customJS = await jsResponse.text();*/

  const qualityLevelLabel = (data: QualityLevel, mediaType: string) => {
    if (mediaType == 'video') return data.width + 'p';
  };

  const textTrackLabel = (textTrack: TextTrack) => {
    switch (textTrack.srclang) {
      case 'eng':
        return 'English';
      case 'fre':
        return 'Français';
    }
  };
  const audioTrackLabel = (audiotrack: AudioTrack) => {
    switch (audiotrack.data?.lang) {
      case 'eng':
        return 'English';
      case 'fre':
        return 'Français';
    }
  };

  //@ts-ignore
  window.blastreamPlayer = new BlastreamPlayer(
    document.getElementById('my-player') as HTMLElement,

    {
      
      source: {
        //url: 'https://live3.blastream.com/vod/__definst__/wis1/wis1_3522-104683/1750757392/mp4:1750757392/playlist.m3u8',
        url: source.url, //'https://secure-vod.blastream.com/bcdn_token=D0h_wRVRFP3W1b_rE9zpBqXW8vIcTg7Hp_q04MqHqEc&expires=1746532331&token_path=%2F123733d1-a5f6-4498-adc4-8cc003b40910/123733d1-a5f6-4498-adc4-8cc003b40910/playlist.m3u8', //'https://dash.akamaized.net/dash264/TestCasesIOP41/MultiTrack/alternative_content/2/manifest_alternative_content_ondemand.mpd', //source.url, //"https://bb.dev.ef.invaders.stream/api/whep/test",
        //playbackMode: PlaybackMode.LIVE,
        /*textTracks: [
          {
            src: 'https://secure-vod.blastream.com/123733d1-a5f6-4498-adc4-8cc003b40910/captions/en-auto.vtt',
            kind: TextTrackKind.SUBTITLES,
            srclang: 'eng',
            label: 'English',
          },
          {
            src: 'https://secure-vod.blastream.com/123733d1-a5f6-4498-adc4-8cc003b40910/captions/fr-auto.vtt',
            kind: TextTrackKind.SUBTITLES,
            srclang: 'fre',
            label: 'Français',
          },
        ],*/
        //sourceType: SourceType.ALTERNATIVE_LANGUAGE,
        /*alternativeLanguageSources: [
          {
              "url": "https://loreal.streamakaci.com/bcdn_token=--1wRc20WSxFFj7vJWEvb0w4EQgvM5w-2BvhZEDqOcw&expires=1749840381&token_path=%2Floreal%2Ffl2025%2Fpl-en/loreal/fl2025/pl-en/manifest.m3u8",
              "language": "en",
              "code": "en"
          },
          {
              "url": "https://loreal.streamakaci.com/bcdn_token=--1wRc20WSxFFj7vJWEvb0w4EQgvM5w-2BvhZEDqOcw&expires=1749840381&token_path=%2Floreal%2Ffl2025%2Fpl-en/loreal/fl2025/pl-en/manifest.m3u8",
              "language": "fr",
              "code": "fr"
          }
      ],
        /*alternativeLanguageSources: [{
              url: "https://blastream.com/demo/hls/elephants_dream/en.m3u8",
              language: 'English',
              code: 'en'
          },{
              url: "https://blastream.com/demo/hls/elephants_dream/es.m3u8",
              language: 'Spanish',
              code: 'es'
          }],*/
        //playbackMode: PlaybackMode.LIVE,
        streamType: StreamType.HLS,
        //playbackMode: PlaybackMode.DVR,
        //streamType: StreamType.DASH,
        //startTime: 15,
        //endTime: 25,
        /*textTracks: [          
          {
            src: '/text-tracks/subtitles.vtt',
            kind: TextTrackKind.SUBTITLES,
            srclang: 'eng',
            label: 'English',
           
          }
        ],*/
      },
      fit: Fit.COVER,
      //background: true,
      //mute: true,
      /*logo: {
        url: 'https://www.blastream.com/wp-content/uploads/2021/06/logo_white-300x62.png',
        position: LogoPosition.TOP_RIGHT,
        //hideOnMouseOut: true,
        //maxWidth: 50,
      },*/
      //loop: true,
      rewind: true,
      cta: {
        title: 'cliquez ici',
        url: 'https://www.blastream.com',
      },
      /*providersOptions: {
        hls: {
          preventLoopBack: true,
        },
      },*/
      //controls: {
      //  settings: { click: ClickAction.CONTROLS },
      //},
      /*colors: [
      { value: '#F38C27', elements: [UiElement.CONTROL_ICON, UiElement.TITLE] },
      {
        value: '#bd2121',
        elements: [UiElement.PROGRESS_BAR, UiElement.CTA_BACKGROUND],
      },
    ],
      plugins: [
        {
          name: 'Boilerplate',
          positions: [
            {
              name: 'HelloWorld',
              position: {
                position: ControlsPosition.BOTTOM_LEFT,
                index: 0,
              },
            },
          ],
          options: {},
        },
      ],*/
      /*
      controls: {
        bottomLeft: [Control.FULLSCREEN],
        bottomRight: [],
      },*/
      initialValues: {
        autoSelectWithViewerLanguage: true
      },
      /*initialValues: {
        volume: 0.5,
        
        audioTrackIndex: 1,
        qualityLevelVideoIndex: 2,
      },*/
      /*controls: {
        middle: [
          ControlMiddle.PLAY,
          ControlMiddle.SEEK_CONTROL_FORWARD,
          ControlMiddle.SEEK_CONTROL_REWIND,
        ],
        subMenu: [
          ControlSubmenu.QUALITYLEVELS_SELECTOR,
          ControlSubmenu.PLAYBACKRATES_SELECTOR,
        ],
        bottomRight: [Control.SUB_MENU],
      },*/
      /*controls: {
        hideList: [Control.PLAY],
        specificDevices: [
          {
            device: {},
            size: 'm',
            controls: {
              hideList: [Control.PIP],
            },
          },
          {
            device: {},
            size: 'xs',
            controls: {
              hideList: [Control.PIP, Control.FULLSCREEN],
            },
          },
        ],
      },*/
      playbackRates: [1, 2],

      onBeforeInit: (sdk: BlastreamPlayer) => {
        console.log('onBeforeInit', sdk);
        /*console.log('onBeforeInit', 'options', sdk.options().setOptions({
          source: {
            url: 'https://www.blastream.com/demo/hls/elephants_dream/index.m3u8',
          }
        }));*/
        sdk.on('ready', () => {
          console.log('onBeforeInit', 'Player is ready');         
        });
        sdk.on('error', (error: any) => {
          console.log('onBeforeInit', 'Player error:', error);
          
        });
        //sdk.pluginsManager.registerPlugin(new Quanteec());
      },

      locale: {
        //lang: 'en',
        //fallback_lang: 'fr',
        translations: {
          fr: {
            Play: 'Jouer',
            //'Unknown error': 'hmmm',
          },
        },
        hooks: {
          //qualityLevelLabel: qualityLevelLabel,
          //textTrackLabel: textTrackLabel,
          //audioTrackLabel: audioTrackLabel,
          errorLabel: function (code: any) {
            console.log('Blastream error code:', code);
            return 'ppp'
          }
        },
      },
      /*providersOptions: {
      hlsNative: {
        debug: true
      }
    },*/
      //css: customCSS,
      //js: customJS,
      autoplay: Autoplay.NO,
      //poster: '/logo512.png',
    },
  );
  /*
  window.BlastreamPlayer.on('ready', () => {
    alert('ready');
  });
  window.BlastreamPlayer.on('init', () => {
    alert('init');
  });*/
  //@ts-ignore
  window.blastreamPlayer.on('toggleControlsChanged', (status: string) => {
    //console.log('toggleControlsChanged', status);
    //@ts-ignore
    document.getElementById('logger').innerHTML = status;
  });
//@ts-ignore
  window.blastreamPlayer.on('mouseOver', (status: string) => {
    console.log('mouseOver', status);
    
  });

}

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

declare global {
  interface Window {
    BlastreamPlayer: any;
  }
}

let sources = [
  {
    url: firstUrl,
    description: 'Live hls, multi quality levels',
  },
  {
    url: 'https:/www.blastream.com/demo/mp4/BigBuckBunny_320x180.mp4',
    label: 'Mp4 only',
  },
  {
    url: 'https://blastream.com/demo/hls/elephants_dream/index.m3u8',
  },
  {
    url: 'http://' + document.location.hostname + ':3333/app/test/llhls.m3u8',
  },
  {
    url:
      'http://' + document.location.hostname + ':3333/app-dvr/test/llhls.m3u8',
  },
  {
    url: 'https://rdmedia.bbc.co.uk/testcard/vod/manifests/avc-full.mpd',
  },
  {
    url: 'https://api-146-59-146-197.blastream.com/app/live/playlist.m3u8'
  }
];

const form = urlParams.get('form');
const react = urlParams.get('react');
//if get param in url with form=1 then show form
if (form) {
  //append a css stylesheet
  const css = document.createElement('link');
  css.rel = 'stylesheet';
  css.href = './semantic.min.css';
  document.head.appendChild(css);
  const element = document.getElementById('my-player');
  if (element) {
    const root = ReactDOM.createRoot(element);
    root.render(<PlayerBuilder />);
  }
} else {
  if (react) {
  } else {
    if (!inIframe()) {

      
      //get sources from url
      document.head.innerHTML += ` <meta name="viewport" content="width=device-width, initial-scale=1" />`;
      let div = document.createElement('div');
      div.innerHTML = `
      <style>
      html, body {
        margin: 0;
        padding: 0;
        overflow-x: hidden;
      }
      /*#my-player{
        width:200px;
        height:500px;
      }*/
      </style>
        <select id="source" onchange="document.location.href = '//' + document.location.host + document.location.pathname + '?url=' + this.options[selectedIndex].value">
          ${sources.map((source) => `<option ${url == source.url ? 'selected="selected"' : ''}" value="${source.url}">${source.description || source.url}</option>`)}
        </select>
        <button onclick="document.getElementById('my-player').style.width='341px'">
          341px
        </button>
        <button onclick="document.getElementById('my-player').style.width='749px'">
          749px
        </button>
        <button onclick="document.getElementById('my-player').style.width='1261px'">
          1261px
        </button>
        <button onclick="window.blastreamPlayer.destroy(); window.blastreamPlayer = new BlastreamPlayer(document.getElementById('my-player'),{source: {url: 'https://www.blastream.com/demo/mp4/BigBuckBunny_320x180.mp4'}})">Change</button>
      `;
      document.body.prepend(div);
      window.BlastreamPlayer = BlastreamPlayer;
      initPlayer();
    } else {
      window.BlastreamPlayer = BlastreamPlayer;
    }
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
